import { render } from "./TaffyBtn.vue?vue&type=template&id=43854528&scoped=true"
import script from "./TaffyBtn.vue?vue&type=script&lang=js"
export * from "./TaffyBtn.vue?vue&type=script&lang=js"

import "./TaffyBtn.vue?vue&type=style&index=0&id=43854528&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43854528"]])

export default __exports__